import styled from 'styled-components'
import { InlineInput } from '@velasca/ui/inline-input'

export const Wrapper = styled.div`
  text-align: center;
  max-width: 50rem;
  margin: 0 auto;

  @media screen and (min-width: 992px) {
    max-width: 100%;
  }
`

export const StyledInlineInput = styled(InlineInput)`
  margin: 2.4rem auto 1.2rem;
  max-width: 46rem;

  input {
    color: ${({ theme }) => theme.colors.text.primary};
    &::placeholder {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }
`

export const PolicyTextContainer = styled.div`
  margin: 1.5rem 0;
  text-align: left;
`

export const TextWrapper = styled.div`
  max-width: 36rem;
  margin: 0 auto;
  margin-top: 2.4rem;
`
